<template>
  <div class="youtaofang">
       <topTitle title="钱湖柏庭" :list="list" :newData="newData"></topTitle>
        <div class="content">
            <div class="item" v-for="(item,index) in list2" :key="index" @mouseover="buttonIndex=index" @mouseleave="buttonIndex=1000" @click="navGetTo(item)">
                <img :src="item.img" alt="">
                <div class="item_show" v-if="buttonIndex==index">
                    <div></div><p>{{item.title}}</p><div></div>
                </div>
            </div>
        </div>
  </div>
</template>
  <script>
  import topTitle from "../rightTopTitle";
export default {
  name: "youtaofang",
  data() {
    return {
        list: [
        {
          title: "项目简介",
          small_title: "PROJECT INTRODUCTION",
          hasTitle: "项目简介",
        },
        {
          title: "柏庭相册",
          small_title: "BOTING PHOTO ALBUM",
          hasTitle: "柏庭相册",
        },
        {
          title: "项目位置",
          small_title: "PROJECT LOCATION",
          hasTitle: "项目位置",
        },
        {
          title: "新闻中心",
          small_title: "NEW CENTER",
          hasTitle: "新闻中心",
          children: [
            {
              title: "2020",
              id: "1",
            },
            {
              title: "2019",
              id: "2",
            },
            {
              title: "2018",
              id: "3",
            },
          ],
        },
      ],
      newData:1,
        list2:[{
            img:require('../../assets/image/home/home_xiangce1.png'),
            title:'居',
            id:0
        },
        {
            img:require('../../assets/image/home/home_xiangce2.png'),
             title:'学',
             id:1
        },
        {
            img:require('../../assets/image/home/home_xiangce3.png'),
             title:'食',
             id:2
        },{
            img:require('../../assets/image/home/home_xiangce4.png'),
             title:'乐',
             id:3
        }],
        buttonIndex:1000
    };
  },
  methods: {
    navGetTo(e){
      console.log(e);
        this.$router.push({
        path: "/Home/photoList",
        query: { majorName: e.id },
      });
    }
  },
  mounted: function() {},
  components: {
      topTitle
  },
   props: {
    
  },
};
</script>
<style scoped="scoped">
.youtaofang{
    width: 100%;
    height: 100%;

}
.content{
    padding: 0.7375rem 0.5625rem;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
}
.item{
    width: 5.25rem;
height: 3.9375rem;
border-radius: 10px;
margin-bottom: 0.8rem;
position: relative;
cursor: pointer;
}
.item img{
      width: 5.25rem;
/* height: 3.9375rem; */
border-radius: 10px;

}
.item_show{
    position: absolute;
      width: 5.25rem;
height: 3.9375rem;
border-radius: 10px;
top: 0;
left: 0;
background-color: rgba(0,0,0,0.5);
display: flex;
justify-content: center;
align-items: center;

font-size: 0.7375rem;
font-family: PingFang SC;
font-weight: 500;
color: #FFFFFF;
}
.item_show div{
    width: 0.2375rem;
height: 2px;
background: #FFFFFF;
margin: 0 0.225rem;
}

</style>